export default {
  titles: {
    default: '¡Recordatorio de pedido programado!',
    external_delivery: '¡Conductor asignado!',
  },
  labels: {
    pickup: 'Recogida: {{time}}',
    serve: 'Servicio: {{time}}',
    preparation_time: 'Tiempo de preparación: {{time}} min',
  },
  buttons: {
    confirm: 'Empezar a preparar ahora',
    print_and_confirm: 'Imprimir y empezar a preparar ahora',
  },
  toasts: {
    something_went_wrong: 'Algo salió mal, inténtalo de nuevo',
  },
};
